import { uploadUri } from '../appConfig';

const renderMenu = (information, type = 'menu') => {
	document.querySelector(`.section-half > .content > .content > .subtitle.-${type}`)
		.classList.add('-show');

	const plaintext = document.createElement('div');
	plaintext.setAttribute('class', 'plaintext');

	let innerHTML = '';
	information.forEach((item) => {
		innerHTML = `${
			innerHTML ? `${innerHTML}·` : ''
		}<a target='_blank' href='${
			type === 'menu' ? item.url : `${uploadUri}/${item.url}`
		}'>${
			item.name
		}</a>`;
	});
	plaintext.innerHTML = innerHTML;

	/**
	 * add menu under the subtitle
	 */
	document.querySelector('.section-half > .content > .content').appendChild(plaintext);
};

export default renderMenu;



// WEBPACK FOOTER //
// ./src/js/restaurant/renderMenu.js